import React, { useMemo } from 'react';
import { AppointmentMeHey } from './AppointmentMeHeyUtils';
import { formatTimeRange } from 'react-lib/utils/dateUtils';
import { convertStringToColor } from "react-lib/apps/MEH/sequence/ScheduleSetting";

interface CardInMonthMeHeyProps {
  rounds: AppointmentMeHey;
  onClick?: (e?: React.MouseEvent) => void;
  compact?: boolean;
  isSelected?: boolean;
}

const CardInMonthMeHey: React.FC<CardInMonthMeHeyProps> = (props) => {
  const timeText = formatTimeRange(props.rounds.startTime, props.rounds.endTime);

  // Get color from doctor name using convertStringToColor
  const colors = useMemo(() => {
    const doctorName = props.rounds.doctor || props.rounds.title || 'default';
    return convertStringToColor(doctorName);
  }, [props.rounds.doctor, props.rounds.title]);
  
  console.log('colors: ', colors);
  return (
    <div
      className={`rounds-card ${props.compact ? 'compact' : ''} ${props.isSelected ? 'selected' : ''}`}
      onClick={props.onClick}
      style={{
        cursor: props.onClick ? 'pointer' : 'default',
        backgroundColor: colors.dark,
        color: colors.textDark,
        border: `1px solid ${colors.medium}`
      }}
    >
      <div className="rounds-card-content">
        {props.rounds.ishaveAppointment && (
          <span className="rounds-indicator-dot"></span>
        )}
        <span className="rounds-time">{timeText}</span>
        <span className="rounds-title">{props.rounds.title}</span>
      </div>
      {!props.compact && props.rounds.location && (
        <div className="rounds-location">{props.rounds.location}</div>
      )}
    </div>
  );
};

export default CardInMonthMeHey;